import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import 'tom-select/dist/js/plugins/dropdown_input'

export default class extends Controller {
  static targets = ["select"]

  connect() {
    const plugins = ['dropdown_input']
    if (this.selectTarget.dataset.clearButton === "true") {
      plugins.push("clear_button")
    }
    const enableSuggestions = this.selectTarget.dataset.enableSuggestions === 'true';

    this.tomSelect = new TomSelect(this.selectTarget, {
      plugins,
      placeholder: this.selectTarget.dataset.placeholder,
      allowEmptyOption: true,
      closeAfterSelect: true,
      searchable: this.selectTarget.dataset.searchable === "true",
      render: {
        no_results: function(data, escape) {
          const suggestionMessage = `
            <div class="flex justify-between text-12">
              <span>Don’t see your school? Tell us—we’ll add it fast!</span>
              <a data-turbo-frame="modal" class="text-blue-400 font-bold" href="/school_suggestions/new?title=${encodeURIComponent(data.input)}">Add School</a>
            </div>`;
          const standardMessage = `<div class="no-results">No results</div>`;
          return enableSuggestions ? suggestionMessage : standardMessage;
        },
        option_create: function(data, escape) {
          return '<div class="create">Add <strong>' + escape(data.input) + '</strong>&hellip;</div>';
        }
      },
      onInitialize: function() {
        const input = this.control_input;

        if (input) {
          input.classList.add('ts-input-element');
        }
      }
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
